module.exports = __webpack_public_path__ + "img/1696391859903-WhatsApp Image 2023-10-04 at 11.57.19.jpeg.1f362580.webp";